import styled from 'styled-components';
import Checkbox from '@minecraft.checkbox';
import { media } from '@minecraft.themes';

export const TableCheckboxCell = styled.div`
  padding: 0.5rem 0 0 1rem;

  ${media.lg`
    padding: 0.5rem 0 0.5rem 0.5rem;
  `}
`;

// Base table cell styles
export const BaseCell = styled.span<{ $wrapText?: boolean }>`
  font-size: 0.75rem;
  line-height: 1rem;
  margin: 0;
  white-space: ${({ $wrapText = false }): string => ($wrapText ? 'normal' : 'nowrap')};
  height: 68px;
`;

// used in cells where content is rendered as a column
// i.e. elements stack top-to-bottom, centered vertically, aligned left
// this is the default for most cell renderers
export const StyledColumnCell = styled(BaseCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

// used in cells that should be left-aligned (towards start of row)
export const StyledLeftCell = styled(BaseCell)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

// used in cells where content is centerd vertically and horizontally
// this is used for talent response & rep response icon cells
export const StyledCenteredCell = styled(BaseCell)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

// used to render content that should be truncated with ellipsis (i.e. "example text" renderds as "examp..." if not enough space)
export const StyledTruncatable = styled.span<{ $weight?: string }>`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${(props): string => props.$weight || '400'};
`;

// used to render the checkboxes in the grid
export const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  border: 0;

  label {
    margin: 0;
  }
`;
